<!--
 * @Date: 2020-05-19 11:23:50
 * @LastEditors: 黄栋
 * @LastEditTime: 2020-05-26 15:05:38
 * @FilePath: /xy-pc/src/views/userCenter/myorder/classList.vue
--> 
<template>
  <div class="student_myclass" style="width:100%">
    <el-tabs v-model="activeName">
      <el-tab-pane label="我的订单" name="first"></el-tab-pane>
    </el-tabs>
    <div style="min-height:50vh " class="clearfix">
      <!-- 订单列表 -->
      <div class="order_list" v-for="(item, index) in orderList" :key="index" v-if="item.classes">
        <img
          @click="$router.push({path:'/classOrderDetail',query:{id:item.id}})"
          :src="item.classes.thumb_image"
          alt
        />
        <div class="order_right">
          <div class="order_head">{{item.classes.name}}</div>
          <div class="clearfix">
            <div style="float:left">
              <div class="order_number">订单号{{item.sn}}</div>
              <div class="order_time">时间 {{item.created_at}}</div>
            </div>
            <div style="float:right">
              <div class="payment payment1" v-if="item.status==-1">未支付</div>
              <div class="payment" v-if="item.status==1">已支付</div>
              <div class="payment payment1" v-if="item.status==2">已取消</div>
            </div>
          </div>
          <div style=" overflow: hidden;float: left;width: 100%;">
            <div class="order_price">￥{{item.realy_price}}</div>
            <div style="float:right">
              <el-button plain type="primary" @click="toPay(item)" v-if="item.status==-1">去支付</el-button>
              <el-button
                plain
                @click="cancelOrder(item.id)"
                v-if="item.status==-1"
                type="danger"
              >取消订单</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin:20px 0 40px;text-align: center;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="limit"
        layout=" sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog width="900px" :visible.sync="showdialog">
      <el-row>
        <el-col :span="12">
          <p class="title">订单信息</p>
          <p class="listItem">订单金额：￥{{dialogform.realy_price}}</p>
          <p class="listItem">订单号：{{dialogform.sn}}</p>
          <p class="listItem">订单时间：{{dialogform.created_at}}</p>
        </el-col>
        <el-col :span="12">
          <p class="title">打款信息</p>
          <p class="listItem">单位：{{dialogform.company_name}}</p>
          <p class="listItem">卡号：{{dialogform.bank_card}}</p>
          <p class="listItem">银行：{{dialogform.bank_name}}</p>

          <!-- <p class="listItem">备注：85478356475647</p> -->
          <!-- <img style="width:150px" src="../../../assets/image/WechatIMG172.png"/> -->
        </el-col>
      </el-row>
      <p style="text-align:center;padding-top:40px;font-size:16px">
        转账时请备注：
        <strong>班级课程{{dialogform.id}}</strong>
      </p>
      <div style="text-align:center;margin-top:40px">
        <el-button style="width:100px" type="primary" @click="showdialog=false">确定</el-button>
      </div>
      <p style="text-align:center;padding-top:40px;font-size:16px">
        财务转账：
        <strong>0551-65652128</strong>
      </p>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "classList",

  data() {
    return {
      page: 1,
      limit: 10,
      total: 0,
      activeName: "first",
      orderList: [],
      showdialog: false,
      dialogform: {},
    };
  },

  created() {
    this.getOrderList();
    this.$http({
      url: "/api/v1/configs/value",
      method: "get",
      params: { name: "system_collect_money_account" },
    }).then((res) => {
      if (res.status == 200) {
        this.dialogform = res.data.value;
      } else {
        this.$message.error(res.msg);
      }
    });
  },

  methods: {
    getOrderList() {
      this.$http({
        url: "/api/v1/auth/orders",
        method: "get",
        params: { page: this.page, limit: this.limit },
      }).then((res) => {
        if (res.status == 200) {
          this.orderList = res.data.orders;
          if (res.data.total) {
            this.total = res.data.total;
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    toPay(item) {
      this.dialogform = Object.assign({}, this.dialogform, item);
      this.showdialog = true;
      // this.$router.push({
      //   path: "/classOrderRes",
      //   query: {
      //     created_at: item.created_at,
      //     orderId: item.id,
      //     sn: item.sn,
      //     realy_price: item.realy_price,
      //   },
      // });
    },
    /**每页数 */
    handleSizeChange(val) {
      this.limit = val;
      this.page = 1;
      this.getOrderList();
    },
    /**当前页 */
    handleCurrentChange(val) {
      this.page = val;
      this.getOrderList();
    },
    cancelOrder(id) {
      this.$confirm(`确定取消订单?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http({
          url: "api/v1/auth/orders/cancel/" + id,
          method: "PUT",
        }).then((res) => {
          if (res.status == 200) {
            this.getOrderList();
            this.$message.success(res.msg);
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  color: rgba(80, 80, 80, 1);
  font-size: 22px;
  margin-bottom: 10px;
}
.listItem {
  margin: 5px 0;
  font-size: 16px;
  color: #333;
  text-align: left;
}
.Personal {
  background: #fff;
}
.Personal_left {
  width: 140px;
  height: 315px;
  left: 415px;
  top: 70px;
  position: relative;
}
.contant {
  width: 960px;
  height: 414px;
  left: 615px;
  top: -240px;
  position: relative;
}
.Personal_left li {
  width: 107px;
  height: 27px;
  color: rgba(120, 125, 130, 1);
  font-size: 16px;
  margin-top: 13px;
}
.Personal_left li img {
  width: 20px;
  height: 20px;
  font-size: 20px;
  color: rgba(120, 125, 130, 1);
  position: relative;
  color: #787d82;
  top: 4px;
}
.Personal_left .active {
  width: 140px;
  height: 41px;
  color: #fff;
  background-color: rgba(42, 130, 228, 1);
  border-radius: 12px;
  line-height: 41px;
  text-align: center;
  position: relative;
  left: -26px;
}
.Personal_right {
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  position: relative;
}
.Personal_right .Personal_title {
  height: 28px;
  top: -29px;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  line-height: 150%;
  width: 74px;
}
.Personal_hen {
  width: 960px;
  height: 1px;
  color: rgba(80, 80, 80, 1);
  background-color: rgba(153, 153, 153, 1);
  font-size: 14px;
  line-height: 150%;
  text-align: center;
  position: relative;
  top: -25px;
}
.contant_list {
  margin-top: 15px;
  height: 85px;
}
.Personal_right .blues {
  color: rgba(42, 130, 228, 1);
}
.Personal_right .blue {
  width: 74px;
  height: 3px;
  left: 0px;
  top: -23px;
  color: rgba(80, 80, 80, 1);
  background-color: rgba(42, 130, 228, 1);
  font-size: 14px;
  line-height: 150%;
  text-align: center;
  position: relative;
}
.order_list {
  width: 990px;
  height: 141px;
  left: 589px;
  top: 648px;
  img {
    width: 266px;
    height: 125px;
    float: left;
    cursor: pointer;
  }
  .order_head {
    width: 693px;
    height: 43px;
    color: rgba(80, 80, 80, 1);
    font-size: 18px;
    line-height: 150%;
    text-align: left;
  }
  .order_number {
    height: 24px;
    color: rgba(128, 128, 128, 1);
    font-size: 16px;
    line-height: 150%;
    text-align: left;
  }
  .payment {
    width: 68px;
    height: 27px;
    color: rgba(22, 184, 88, 1);
    font-size: 18px;
    line-height: 150%;
    text-align: left;
    float: right;
  }
  .order_right {
    float: left;
    padding-left: 20px;
  }
  .order_price {
    width: 112px;
    height: 40px;
    color: rgba(238, 104, 72, 1);
    font-size: 24px;
    line-height: 150%;
    text-align: left;
    float: left;
  }
  .order_chance {
    width: 115px;
    height: 38px;
    color: rgba(42, 130, 228, 1);
    background-color: rgba(226, 246, 219, 0.4142857142857143);
    border-radius: 19px;
    font-size: 14px;
    line-height: 38px;
    border: rgba(121, 180, 246, 0.65) solid 1px;
    text-align: center;
    float: right;
    margin-left: 20px;
    cursor: pointer;
  }
  .chance1 {
    width: 115px;
    height: 35px;
    color: rgba(253, 4, 25, 1);
    background-color: rgba(252, 210, 213, 0.5428571428571428);
    border-radius: 14px;
    font-size: 14px;
    line-height: 38px;
    border: rgba(253, 4, 25, 0.2714285714285714) solid 1px;
    text-align: center;
    float: right;
    margin-left: 20px;
  }
  .payment1 {
    color: rgba(252, 44, 44, 1);
  }
}
</style>